import { useQueryUser } from '@/hooks/query/useQueryUser';

/**
 * Effective mini-mode gate from the user's account opt out.
 * Mini-mode surfaces (the pill, PiP provider, auto-media-session) should read
 * this hook.
 *
 * The user preference is stored server-side in `session_settings.is_mini_mode_enabled`
 * so it follows the account across devices. Defaults to `true` (matches BE
 * default) when the field is missing, e.g. while the user query is loading.
 */
export const useIsMiniModeEnabled = () => {
  const userEnabled = useQueryUser(
    (data) => data.session_settings?.is_mini_mode_enabled
  ).data;
  return userEnabled ?? true;
};
